module.exports = __webpack_public_path__ + "img/ifp.06fb7462.png";